

























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import QTable from 'quasar/src/components/table/QTable.js';
import { Prop, ProvideReactive } from 'vue-property-decorator'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import Heading from '@/modules/common/layout/components/shared/Heading.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import WriterContentItemTableRow from '@/modules/content-item/components/writer/table/WriterContentItemTableRow.vue'

@Component({
  components: {
    Heading,
    FilterRow,
    TesTable,
    ContentsIndexRow: WriterContentItemTableRow
  }
})
export default class ContentsIndexPage extends Vue {
  @ProvideReactive()
  @Prop() contents !: any

  private rowComponent = WriterContentItemTableRow

  private columns: QTable['columns'] = [
    {
      name: 'id',
      field: 'id',
      label: 'شناسه',
      align: 'left'
    },
    {
      name: 'title',
      field: 'title',
      label: 'عنوان',
      align: 'left',
      style: this.$q.screen.gt.sm ? 'max-width:300px' : ''
    },
    {
      name: 'main_keyword',
      field: 'main_keyword',
      label: 'کلمه کلیدی',
      align: 'left',
      style: this.$q.screen.gt.sm ? 'max-width:200px' : ''
    },
    {
      name: 'step',
      field: 'step',
      label: 'مرحله',
      align: 'left'
    },
    {
      name: 'deliver_at',
      field: 'deliver_at',
      label: 'تاریخ تحویل',
      align: 'left'
    },
    {
      name: 'status',
      field: 'status',
      label: 'وضعیت',
      align: 'left'
    },
    {
      name: 'operation',
      label: '',
      field: 'operation',
      align: 'left'
    }
  ]

}
